import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Fhe, Sensor, DriveElec, SmartPlug, HeatAndCool } from '.';

class ProductDetail extends PureComponent {
    static propTypes = {
        productType: PropTypes.string
    };
    static defaultProps = {
        productType: null
    };

    render() {
        const { productType } = this.props;

        const detailContentByType = {
            fhe_product: () => <Fhe {...this.props} />,
            sensor: () => <Sensor {...this.props} />,
            drive_elec: () => <DriveElec {...this.props} />,
            smart_plug: () => <SmartPlug {...this.props} />,
            heat_and_cool: () => <HeatAndCool {...this.props} />
        };
        return detailContentByType[productType]();
    }
}

export default ProductDetail;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/Product/ProductDetail.js